import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Footer from "./component/Footer";
import ProcessoSeletivo from "./Pages/ProcessoSeletivo";
import QuemSomos from "./Pages/QuemSomos";
import Navbar1 from "./component/Navbar1";
import ProgressBar from "./component/ProgressBar";
import ScrollToTop from "./component/ScrollToTop";
import Contato from "./Pages/Contato";
import LGPD from "./Pages/LGPD";
import TermosDeUso from "./Pages/TermosDeUso";
import Sequoia from "./Pages/Sequoia";
import Home from "./Pages/Home";
import RenegociacaoDividasRurais from "./Pages/AreasAtuacao/RenegociacaoDividasRurais";
import DefesaExecucoes from "./Pages/AreasAtuacao/DefesaExecucoes";
import Impenhorabilidade from "./Pages/AreasAtuacao/Impenhorabilidade";
import SeguroRural from "./Pages/AreasAtuacao/SeguroRural";
import IndenizacaoPerdas from "./Pages/AreasAtuacao/IndenizacaoPerdas";
import RevisaoJuros from "./Pages/AreasAtuacao/RevisaoJuros";

function App() {
  return (
    <Router>
      <div id="google_translate_element"></div>
      <ScrollToTop />
      <ProgressBar />
      <div className="flex-container">
        <Navbar1 />
        <main className="flex-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/QuemSomos" element={<QuemSomos />} />
            <Route path="/ProcessoSeletivo" element={<ProcessoSeletivo />} />
            <Route path="/Contato" element={<Contato />} />
            <Route path="/LGPD" element={<LGPD />} />
            <Route path="/TermosDeUso" element={<TermosDeUso />} />
            <Route path="/Sequoia" element={<Sequoia />} />
            {/* Rotas para áreas de atuação */}
            <Route
              path="/areas/renegociacao-dividas"
              element={<RenegociacaoDividasRurais />}
            />
            <Route
              path="/areas/defesa-execucoes"
              element={<DefesaExecucoes />}
            />
            <Route
              path="/areas/impenhorabilidade"
              element={<Impenhorabilidade />}
            />
            <Route path="/areas/seguro-rural" element={<SeguroRural />} />
            <Route
              path="/areas/indenizacao-perdas"
              element={<IndenizacaoPerdas />}
            />
            <Route path="/areas/revisao-juros" element={<RevisaoJuros />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
